import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Container, Row, Col, Card } from "react-bootstrap";

// --- Step 1: Import motion from Framer Motion ---
import { motion } from "framer-motion";



// --- Step 2: Define animation variants ---
// This variant will be for the container of the logos (the Row)
// It uses staggerChildren to animate each child one after the other
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1, // Time delay between each child animating
    },
  },
};

// This variant will be for each individual logo (the Col/Card)
const itemVariants = {
  hidden: { y: 20, opacity: 0 }, // Start 20px below and invisible
  visible: {
    y: 0,
    opacity: 1, // Animate to original position and fully visible
  },
};

const OurPartners = () => {
  const partners = [
    { src: "assets/images/partners/image-1.png", alt: "Smiley" },
    { src: "assets/images/partners/image-2.jpg", alt: "Partner Logo 2" },
    { src: "assets/images/partners/image-3.jpg", alt: "Give India" },
    { src: "assets/images/partners/image-4.jpg", alt: "OTELP Plus" },
    { src: "assets/images/partners/image-5.png", alt: "OPELIP" },
    { src: "assets/images/partners/image-6.jpg", alt: "Cuttack Municipal Corporation" },
    { src: "assets/images/partners/image-7.jpg", alt: "Bhubaneswar Municipal Corporation" },
    { src: "assets/images/partners/image-8.jpg", alt: "Rourkela Municipal Corporation" },
    { src: "assets/images/partners/image-9.jpg", alt: "Department of Forest & Environment" },
    { src: "assets/images/partners/image-10.jpg", alt: "Rural Development & DM Department" },
    { src: "assets/images/partners/image-12.jpg", alt: "Department of Urban Development" },
    { src: "assets/images/partners/image-11.jpg", alt: "Housing & Women & Child Development" },
  ];

  return (
    <>
      <Header />

      {/*Start Page Header*/}
      <section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(assets/images/backgrounds/partner.png)",
          }}
        ></div>
        <div className="shape1 float-bob-x">
          <img src="assets/images/shapes/page-header-shape1.png" alt=""  style={{ filter: 'hue-rotate(90deg)' }}/>
        </div>
        <div className="shape2">
          <img src="assets/images/shapes/page-header-shape2.png" alt=""  style={{ filter: 'hue-rotate(90deg)' }} />
        </div>
        <div className="container">
          <div className="page-header__inner">
            {/* --- ANIMATION ADDED --- */}
            <motion.h2
              initial={{ opacity: 0, y: -50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              Our Partners
            </motion.h2>

            <motion.p
              style={{ color: "#dad2d0", fontSize: "24px", marginTop: "20px" }}
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              We partner with organizations and communities committed to <br />{" "}
              advancing healthcare, education, and sustainable development,{" "}
              <br /> driving meaningful change together.
            </motion.p>
          </div>
        </div>
      </section>
      {/*End Page Header*/}

     <section className="partners-card-section py-5">
  <Container>
    <motion.div
      className="row g-4"
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
    >
      {partners.map((partner, index) => (
        <Col
          key={index}
          xs={6}
          sm={4}
          md={3}
          lg={2}
          className="d-flex align-items-stretch"
        >
          <motion.div
            className="w-100"
            variants={itemVariants}
            whileHover={{ scale: 1.05, y: -5 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <Card
              className="partner-card p-3 shadow-sm w-100 d-flex justify-content-center align-items-center flex-column"
              style={{ minHeight: "160px" }}
            >
              <Card.Img
                variant="top"
                src={partner.src}
                alt={partner.alt}
                className="partner-img"
                style={{
                  maxWidth: "100%",
                  maxHeight: "100px",
                  objectFit: "contain",
                }}
              />
              {/* --- Added Partner Name Below Image --- */}
              <Card.Text
                className="mt-2 text-center fw-semibold"
                style={{ fontSize: "14px", color: "#333" }}
              >
                {partner.alt}
              </Card.Text>
            </Card>
          </motion.div>
        </Col>
      ))}
    </motion.div>
  </Container>
</section>


      <Footer />
      <a href="#" data-target="html" className="scroll-to-target scroll-to-top">
        <span className="scroll-to-top__wrapper">
          <span className="scroll-to-top__inner" />
        </span>
        <span className="scroll-to-top__text"> Go Back Top</span>
      </a>
    </>
  );
};
export default OurPartners;